class RegisterForm {
  constructor() {
    if (!document.querySelector('form[name="register"]')) {
      return false;
    }

    this.registerForm = document.querySelector('form[name="register"]');
    this.hasAuctionOptIn = document.querySelector('input#auctions_opt_in');
    this.submitButton = document.querySelector('button[type="submit"]')

    // Methods
    this.toggleAuctionsFields = this.toggleAuctionsFields.bind(this);
    this.handleRecaptcha = this.handleRecaptcha.bind(this);

    this.initForm();

    this.hasAuctionOptIn.addEventListener('change', this.toggleAuctionsFields);
    this.registerForm.addEventListener('submit', this.handleRecaptcha);
  }

  toggleAuctionsFields(event) {
    if (event.target.checked) {
      document.querySelector('.tml-auction_address_1-wrap').style.display = '';
      document.querySelector('.tml-auction_address_2-wrap').style.display = '';
      document.querySelector('.tml-auction_city-wrap').style.display = '';
      document.querySelector('.tml-accept_auctions_terms-wrap').style.display = '';
    } else {
      document.querySelector('.tml-auction_address_1-wrap').style.display = 'none';
      document.querySelector('.tml-auction_address_2-wrap').style.display = 'none';
      document.querySelector('.tml-auction_city-wrap').style.display = 'none';
      document.querySelector('.tml-accept_auctions_terms-wrap').style.display = 'none';
    }
    
  }

  initForm() {
    if (!this.hasAuctionOptIn.checked) {
      document.querySelector('.tml-auction_address_1-wrap').style.display = 'none';
      document.querySelector('.tml-auction_address_2-wrap').style.display = 'none';
      document.querySelector('.tml-auction_city-wrap').style.display = 'none';
      document.querySelector('.tml-accept_auctions_terms-wrap').style.display = 'none'; 
    }
  }

  handleRecaptcha(event) {
    event.preventDefault();
    grecaptcha.ready(function() {
        grecaptcha.execute('6Lf9HHgaAAAAAN18tR85dDquwNa96MNA5acCNPVS', { action: 'submit' }).then(function(token) {
            gRecaptchaResponse.value = token;
            HTMLFormElement.prototype.submit.call(document.querySelector('form[name="register"]'));
        });
    });
  }

}

new RegisterForm();